<template>
  <div>
    <create-card route_back="PickupLocations" model_name="obra" :saving="loading.saving">
      <template slot="form">
        <v-form ref="form" lazy-validation>
          <v-stepper v-model="stepper_count" vertical class="ma-5 elevation-0">
            <v-stepper-step :editable="stepper_count > 1" :complete="stepper_count > 1" step="1" >
              Cliente
              <small>Selecione o cliente</small>
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 1" step="1">
              <v-form ref="forms1">
                <SelectOneClient @changeClient="handleChangeClient"></SelectOneClient>
              </v-form>
              <div>
                <v-btn text disabled><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                <v-btn text @click="nextStepper(2)" ><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
              </div>
            </v-stepper-content>
            <v-stepper-step :editable="stepper_count > 2" :complete="stepper_count > 2" step="2" >
              Informações básicas
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 2" step="2">
              <BuildingForm ref="forms2" :building="building"></BuildingForm>
              <div>
                <v-btn text @click="stepper_count = 1"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                <v-btn text @click="nextStepper(3)" ><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
              </div>
            </v-stepper-content>
            
            <v-stepper-step :editable="stepper_count > 3" :complete="stepper_count > 3" step="3" >
              Endereço
            </v-stepper-step>
            <v-stepper-content :complete="stepper_count > 3" step="3">
              <AddressForm ref="forms3" :address="building.address_attributes"></AddressForm>
              <div>
                <v-btn text @click="stepper_count = 2"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
                <f-btn save @click="postBuilding"></f-btn>
              </div>
            </v-stepper-content>

          </v-stepper>
        </v-form>
      </template>
    </create-card>
  </div>
</template>

<script>
import Api from '@/api/index';
import validations from '@/mixins/validations.js'

export default {
  name: "CreateCompany",
  components: {
    SelectOneClient: () => import("@/_backoffice/_financial/components/shared/SelectOneClient.vue"),
    PickupLocationForm: ()=> import("@/_backoffice/_registrations/components/pickup_locations/forms/PickupLocationForm.vue"),
    AddressForm: ()=> import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
    CreateCard: ()=> import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
  },
  mixins:[validations],
  data() {
    return {
      loading: { saving: false },
      dialog: true,
      stepper_count: 1,
      building: {
        name: "",
        comment: "",
        client_id: null,
        address_attributes: {

        }
      },
    }
  },
  methods: {
    handleChangeClient(client_id){
      this.building.client_id = client_id
    },
    postBuilding(){
      this.loading.saving = true
      Api.Building.create(this.building).then(()=>{
        
      }).then(()=>{
        this.successSaved()
        this.building.client_id = null
        this.stepper_count = 1
      })
      .finally(()=>{
        this.loading.saving = false
      })
    },
    nextStepper(number){
      if (this.validateForm(number-1)){
        this.stepper_count = number
      }
    },
    validateForm(number){
      return this.$refs[`forms${number}`].validate()
    },
  },
}
</script>